import { APIResult } from './APIResult';
import { getWishLists } from './GetWishLists/GetWishLists';
import { logAPIErrorToNewrelic, mapWishLists } from './utils';

export const getAndMapWishLists = async (allowedToFail: boolean): Promise<APIResult<ProductWishList[]>> => {
    const wishListsResult = await getWishLists(allowedToFail);

    if (!wishListsResult.success) {
        const result = new APIResult<ProductWishList[]>(wishListsResult);
        logAPIErrorToNewrelic('getAndMapWishLists', ' API returned Non OK', {
            ...wishListsResult,
            response: wishListsResult,
            allowedToFail: allowedToFail,
            result: result,
            errorMessage: result.errorMessage,
            showError: result.showError,
        });
        return result;
    }

    if (!wishListsResult.data) {
        logAPIErrorToNewrelic('getAndMapWishLists', 'Unexpected data scenario | No data', {
            ...wishListsResult,
            response: wishListsResult,
            allowedToFail: allowedToFail,
            errorThrown: true,
        });
        throw Error('Unexpected data scenario');
    }

    const result = new APIResult<ProductWishList[]>();
    result.success = true;
    result.data = mapWishLists(wishListsResult.data);
    return result;
};
